define('modules/profiles/subviews/views/profile.open.full.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "modules/base/views/model.view",
    "text!modules/profiles/subviews/templates/profile.open.full.template.html"
], function (Prospector,
             $, _, Backbone, Marionette,
             ModelView,
             Template) {
    var ProfileOpenFullView = ModelView.extend({
        className: 'buttons follow mBottom10',
        template: _.template(Template),
        initialize: function (options) {
            this.parent = options.parent;
            this.model = options.model;
        },
        mEvents:function(){
            return {
                'click':'openProfile'
            };
        },
        openProfile: function(){
            var newURL = "https://app.relpro.com/#profile/" + this.model.get("identityType") + "/" + this.model.get("source").sourceId + "/" + this.model.get("source").refId;
            chrome.tabs.create({ url: newURL });
        }
    });
    return ProfileOpenFullView;
});

